angular
    .module('annexaApp')
    .component('annexaSelectThirdsPhone', {
        templateUrl: './components/common/annexa-select-thirds-phone/annexa-select-thirds-phone.html',
        controller: ['$filter', '$rootScope', 'NotificationFactory', 'ThirdFactory', 'GlobalDataFactory', 'CommonService', 'Language', '$state', function($filter, $rootScope, NotificationFactory, ThirdFactory, GlobalDataFactory, CommonService, Language, $state) {
            var vm = this;

            vm.languageColumn = Language.getActiveColumn();
			vm.selectedAll = false;

			vm.selectThird = function ($event, index) {
                var checkbox = $event.target;
                vm.thirds[index].selected = checkbox.checked;
                var added = [];
                var removed = [];
                if(vm.thirds[index].addressesOrig){
                	_.forEach(vm.thirds[index].addressesOrig, function(value2){
                		if(checkbox.checked){
                			if(vm.thirds[index].addressesOrig.length == 1){
                				if(!value2.selected){
                					added.push(value2.labelAddress);
                				}
                				value2.selected = true;
                			}else{
                				if(value2.selected){
                					removed.push(value2.labelAddress);
                				}
                				value2.selected = false;
                			}
                		}else{
                			if(value2.selected){
            					removed.push(value2.labelAddress);
            				}
            				value2.selected = false;
                		}
                	});
                }
                if((added && added.length > 0) || (removed && removed.length > 0) ){
                	$rootScope.$broadcast('annexa-select-thirds-phone-selectedThirds', {added: added, removed: removed});
                }
			};

            vm.selectAddress = function ($event, thirdId, addressId) {
            	var checkbox = $event.target;
                var third = $linq(vm.thirds).where("x => x.third.id =="+thirdId).toArray();
                var added = [];
                var removed = [];
                if(third && third.length > 0){
                    _.forEach(third, function(value){
                        if(value.addressesOrig){
                            _.forEach(value.addressesOrig, function(value2){
                                if(value2.id == addressId){
                                    if(checkbox.checked){
                                    	if(!value2.selected){
                        					added.push(value2.labelAddress);
                        				}
                        				value2.selected = true;
                                    }else{
                                    	if(value2.selected){
                        					removed.push(value2.labelAddress);
                        				}
                                    	value2.selected = false;	
                                    }
                                }
                            });
                        }
                    });
                }
                if((added && added.length > 0) || (removed && removed.length > 0) ){
                	$rootScope.$broadcast('annexa-select-thirds-phone-selectedThirds', {added: added, removed: removed});
                }
            };
            
            vm.selectAll = function(){
                var added = [];
                var removed = [];
				_.forEach(vm.thirds, function (value, key) {
					vm.thirds[key].selected = ((vm.selectedAll)?true:false);
	                if(vm.thirds[key].addressesOrig){
	                	_.forEach(vm.thirds[key].addressesOrig, function(value2){
	                		if(vm.selectedAll){
                				if(!value2.selected){
                					added.push(value2.labelAddress);
                				}
                				value2.selected = true;
	                		}else{
	                			if(value2.selected){
	            					removed.push(value2.labelAddress);
	            				}
	            				value2.selected = false;
	                		}
	                	});
	                }
            	});
                if((added && added.length > 0) || (removed && removed.length > 0) ){
                	$rootScope.$broadcast('annexa-select-thirds-phone-selectedThirds', {added: added, removed: removed});
                }
			}
            this.$onInit = function () {
            	if(!vm.title) {
                    vm.title = 'global.literals.thirds';
                }
            	if(vm.thirds !== undefined){
	        		var thirdsAux = angular.copy(vm.thirds);
	        		vm.thirds.length = 0;
	        		if(thirdsAux && thirdsAux.length > 0){
	        			_.forEach(thirdsAux,function(th){
	        				if(th && th.third && th.third.addresses && th.third.addresses.length > 0){
	        					var addresses = [];
	        					_.forEach(th.third.addresses,function(thad){
	                				if(thad && thad.addressType == 'TELEMATIC_MOBILEPHONE'){
	                					thad.labelAddress = CommonService.getThirdAddress(thad);
	                					addresses.push(thad);
	                				}
	                			});
	        					if(addresses && addresses.length > 0){
	        						th.addressesOrig = addresses;
	        						if(th.third && th.third.completeName && th.third.completeName != '') {
	        							th.label = th.third.completeName;
	        		                } else {
	        		                	th.label = CommonService.getThirdCompleteName(th.third);
	        		                }
        		                	th.labelHtml = CommonService.getThirdRelationType(th);
	        						vm.thirds.push(th);
	        					}
	        				}
	        			});
	        		}
            	}else{
            		vm.thirds = [];
            	}

            }            
        }],
        bindings: {
            title: '@?',
            thirds: '='
        }
    })